import { Card } from '@/components/ui/card';

interface ActivitiesSkeletonProps {
  count?: number;
  className?: string;
}

export function ActivitiesSkeleton({ 
  count = 5, 
  className = '' 
}: ActivitiesSkeletonProps) {
  return (
    <div className={`${className}`}>
      {Array.from({ length: count }).map((_, index) => (
        <Card 
          key={index} 
          className="relative w-full h-[87px] bg-white/25 border-b last:border-b-0"
        >
          {/* Thumbnail skeleton - Left side */}
          <div className="absolute left-2 top-2 w-[122px] h-[68px] bg-gray-300 animate-pulse"></div>

          {/* Activity Type Icon skeleton */}
          <div className="absolute left-[148px] top-[12px] w-6 h-6 bg-gray-300 rounded-full animate-pulse"></div>

          {/* Activity Title skeleton */}
          <div className="absolute left-[185px] top-[13px] h-4 bg-gray-300 rounded animate-pulse w-32"></div>

          {/* Entry Point Description skeleton */}
          <div className="absolute left-[147px] top-[36px] h-3 bg-gray-300 rounded animate-pulse w-48"></div>

          {/* User Avatar skeleton */}
          <div className="absolute left-[385px] top-[38px] w-4 h-4 bg-gray-300 rounded-full animate-pulse"></div>

          {/* User Name skeleton */}
          <div className="absolute left-[405px] top-[37px] h-3 bg-gray-300 rounded animate-pulse w-12"></div>

          {/* Date ID skeleton */}
          <div className="absolute right-[19px] top-[16px] h-3 bg-gray-300 rounded animate-pulse w-20"></div>

          {/* Time Badge skeleton */}
          <div className="absolute right-[19px] top-[37px] h-3 bg-gray-300 rounded animate-pulse w-8"></div>
        </Card>
      ))}
    </div>
  );
}
